export default __webpack_public_path__ + "static/refound-dbed6c42598fc26f8504aebf628e218f.svg";